module.exports = __webpack_public_path__ + "img/percentage-laptop.ec2c2c58.svg";